<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <div class="row">
        <!-- Boucle sur les activités -->
        <div 
          class="col-xl-3 col-lg-4 col-md-6" 
          v-for="(activite, index) in activites" 
          :key="index"
        >
          <div class="team-card style1">
            <div 
              class="team-img bg-yellow-600 text-white"
              style="height: 200px; border-radius: 10px; padding: 20px;"
            >
              <div class="flex flex-col items-center justify-center h-full">
                <i :class="getIconForActivity(activite.libelle)" class="activity-icon mb-3"></i>
                <span class="text-xl font-bold text-center">{{ activite.libelle }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="mt-4">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";
import { defineComponent, ref, onMounted } from "vue";
import PaginationComponent from "@/components/Utilities/Pagination.vue";

interface Activite {
  id: number;
  libelle: string;
}

export default defineComponent({
  name: "ActiVite",
  components: { PaginationComponent },
  setup() {
    const activites = ref<Array<Activite>>([]);
    const isLoading = ref(false);

    // Pagination
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(12);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      page.value = page_;
      getActivites(page_, limit_);
    };

    // Charger les activités
    function getActivites(pageNum = 1, limi = 12) {
      isLoading.value = true;
      return ApiService.get(`/all/activites?page=${pageNum}&limit=${limi}`)
        .then(({ data }) => {
          activites.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur lors du chargement des activités");
          activites.value = [];
        })
        .finally(() => {
          isLoading.value = false;
        });
    }

    // Fonction pour attribuer une icône basée sur le libellé
    function getIconForActivity(libelle: string) {
      const lowerLibelle = libelle.toLowerCase();
      
      // Mapping d'icônes basé sur des mots-clés
      // if (lowerLibelle.includes('sport') || lowerLibelle.includes('football') || lowerLibelle.includes('basket')) {
      //   return 'flaticon-football';
      // } else if (lowerLibelle.includes('éducation') || lowerLibelle.includes('école') || lowerLibelle.includes('formation')) {
      //   return 'flaticon-reading';
      // } else if (lowerLibelle.includes('santé') || lowerLibelle.includes('médical') || lowerLibelle.includes('soin')) {
      //   return 'flaticon-healthcare';
      // } else if (lowerLibelle.includes('culture') || lowerLibelle.includes('art') || lowerLibelle.includes('musique')) {
      //   return 'flaticon-music';
      // } else if (lowerLibelle.includes('environnement') || lowerLibelle.includes('nature') || lowerLibelle.includes('écologie')) {
      //   return 'flaticon-leaf';
      // } else if (lowerLibelle.includes('technologie') || lowerLibelle.includes('informatique') || lowerLibelle.includes('digital')) {
      //   return 'flaticon-computer';
      // } else if (lowerLibelle.includes('agriculture') || lowerLibelle.includes('ferme') || lowerLibelle.includes('élevage')) {
      //   return 'flaticon-farmer';
      // } else if (lowerLibelle.includes('commerce') || lowerLibelle.includes('business') || lowerLibelle.includes('entreprise')) {
      //   return 'flaticon-shop';
      // } else if (lowerLibelle.includes('transport') || lowerLibelle.includes('véhicule') || lowerLibelle.includes('logistique')) {
      //   return 'flaticon-delivery-truck';
      // } else if (lowerLibelle.includes('construction') || lowerLibelle.includes('bâtiment') || lowerLibelle.includes('travaux')) {
      //   return 'flaticon-construction';
      // } else if (lowerLibelle.includes('alimentation') || lowerLibelle.includes('nourriture') || lowerLibelle.includes('restaurant')) {
      //   return 'flaticon-fork';
      // } else if (lowerLibelle.includes('enfant') || lowerLibelle.includes('bébé') || lowerLibelle.includes('crèche')) {
      //   return 'flaticon-baby';
      // } else if (lowerLibelle.includes('tourisme') || lowerLibelle.includes('voyage') || lowerLibelle.includes('hôtel')) {
      //   return 'flaticon-airplane';
      // } else if (lowerLibelle.includes('finance') || lowerLibelle.includes('banque') || lowerLibelle.includes('argent')) {
      //   return 'flaticon-money';
      // } else if (lowerLibelle.includes('communication') || lowerLibelle.includes('média') || lowerLibelle.includes('presse')) {
      //   return 'flaticon-megaphone';
      // } else {
      //   // Icône par défaut
      //   return 'flaticon-target';
      // }
    }

    onMounted(() => {
      getActivites();
    });

    return {
      activites,
      isLoading,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      getIconForActivity
    };
  },
});
</script>

<style scoped>
.team-card {
  transition: transform 0.3s ease;
  margin-bottom: 20px;
}

.team-card:hover {
  transform: translateY(-5px);
}

.team-img {
  position: relative;
  overflow: hidden;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.activity-icon {
  font-size: 64px;
  opacity: 0.9;
}
</style>